import { PAGE_URLS as PAYMENTS_PAGE_URLS } from "modules/payments/constants/PageUrls";

import type { UUID } from "utils";

export const BASE_URL = "/connect/refunds";

export const PAGE_URLS = {
  dashboard: "/",
  list: `${BASE_URL}`,
  getLinkToList: (paymentId: UUID) => `${BASE_URL}?transactionId=${paymentId}`,
  getLinkToPaymentRefunds: (paymentId: UUID) =>
    PAYMENTS_PAGE_URLS.getLinkToRefundList(paymentId),
  create: `${BASE_URL}/create`,
  getLinkToCreate: (paymentId: string) =>
    `${BASE_URL}/create?transactionId=${paymentId}`,
  details: `${BASE_URL}/:id`,
  getLinkToDetails: (refundId: UUID) => `${BASE_URL}/${refundId}`,
  paymentDetails: `${BASE_URL}/:id/payments`,
  getLinkToPaymentDetails: (refundId: UUID) =>
    `${BASE_URL}/${refundId}/payments`,
} as const;
